// extracted by mini-css-extract-plugin
module.exports = {"button-wrapper":"ScrollButton_button-wrapper__29WpS","button":"ScrollButton_button__3IJid","gender":"ScrollButton_gender__2Nq04"};